import React from "react";
import Header from "../../header/index";
import { Link } from "react-router-dom";
const Terms = () => {
  return (
    <>
      <div className="hidden lg:block terms-condition">
        <div className="w-[15.5] flex flex-col pt-[20vh]">
          <div className="text-[2.6vw] font-semibold text-white">
            Terms & Conditions
          </div>
          <div className="text-white flex gap-3 justify-center text-[1vw] font-urbanist">
            <Link to="/">
              <button className="hover:text-white hover:scale-110 duration-150">
                Home
              </button>
            </Link>
            /
            <button className="hover:text-white hover:scale-110 duration-150">
              Terms & Conditions
            </button>
          </div>
        </div>
      </div>

      <div className="font-urbanist text-left bg-white text-black p-[5vw] max-w-[90vw] mx-auto">
        <h1 className="text-[3vw] font-bold mb-[3vw]">
          Terms and Conditions for BidCaribbean
        </h1>

        <section className="mb-[3vw] text-[1.5vw]">
          <h2 className="text-[2vw] font-semibold mb-[1vw]">1. Introduction</h2>
          <h2 className="text-[2vw] font-semibold mb-[1vw]">Welcome</h2>
          <p className="">
            We are excited that you have decided to use our services on our
            website,{" "}
            <a
              className="text-blue-800 font-semibold"
              href="http://www.bidcaribbean.co/"
            >
              www.bidcaribbean.co
            </a>{" "}
            (the “Website”). Thank you! We hope you enjoy your experience with
            <strong> BidCaribbean</strong> , a subsidiary of
            <strong> Lux First Choice Cars,</strong>, and our platform for buying
            and selling vehicles in The Bahamas and the Caribbean.
          </p>
          <p >
            These terms and conditions (the “Agreement”) will explain what we
            do, our responsibilities to each other, fee structures, membership
            roles, and more. As used in this Agreement, <strong> “you”</strong>{" "}
            or <strong> “user”</strong> refers to the individual or entity
            accessing the Website, and <strong> “we,” “us,” “Company,” </strong>{" "}
            or <strong> “BidCaribbean” </strong> refers to{" "}
            <strong> Lux First Choice Cars dba BidCaribbean. </strong> The{" "}
            <strong>“parties”</strong> means you and BidCaribbean.
          </p>
          <p >
            The Website consists of various web pages operated by BidCaribbean.
            By using the Website, you agree to the terms, conditions, and
            notices contained herein without modification, including the Member
            Terms and Conditions of <strong> Copart, Inc.</strong> (
            <a href="https://www.iaai.com/TermsOfUse">Copart Terms</a>) and{" "}
            <strong> Insurance Auto Auctions, Inc.</strong> (
            <a href="https://www.iaai.com/TermsOfUse">IAAI Terms</a>).
          </p>
          <p>
            Please read the following terms carefully, and keep a copy for your
            reference. Although we’ve tried to make this Agreement brief and
            simple, there are places where it may still read like a traditional
            contract. There’s a good reason for this:{" "}
            <strong>
              {" "}
              this Agreement forms a legally binding contract between you and
              BidCaribbean.
            </strong>
          </p>
        </section>

        <section className="mb-[3vw] text-[1.5vw]">
          <h2 className="text-[2vw] font-semibold mb-[1vw]">2. About Us</h2>
          <p className="">
            BidCaribbean is a wholesale/retail business registered in The
            Bahamas and operates as a subsidiary of{" "}
            <strong> Lux First Choice Cars</strong>. We are a registered buyer
            at <strong>Copart</strong> and <strong>IAAI</strong>, providing
            broker services for purchasing cars, motorcycles, motor homes, and
            other motorized equipment through our Website for a nominal fee. You
            do not need to register directly with Copart or IAAI to bid on
            vehicles through our platform. BidCaribbean reserves the right to
            use third-party dealer services to facilitate purchases and handle
            paperwork.
          </p>
        </section>

        <section className="mb-[3vw] text-[1.5vw]">
          <h2 className="text-[2vw] font-semibold mb-[1vw]">
            3. Acceptance of Terms
          </h2>
          <p className="">
            By using BidCaribbean, you confirm your acceptance of these terms
            and agree to be bound by them. If you do not agree, you must not use
            the platform. These terms apply to all users, including buyers,
            sellers, and visitors to the Website.{" "}
          </p>
        </section>

        <section className="mb-[3vw] text-[1.5vw]">
          <h2 className="text-[2vw] font-semibold mb-[1vw]">
            4. Services Provided
          </h2>
          <p className="">
            BidCaribbean offers the following services:
          </p>

          <ol className="list-disc pl-[3vw] text-[1.5vw] space-y-[0.5vw] ">
            <li>
              <p className="">
                <strong>International Auctions: </strong>Facilitating the
                purchase of vehicles through third-party platforms like{" "}
                <strong>Copart</strong> and <strong>IAAI.</strong>
              </p>
            </li>

            <li>
              <p className="">
                <strong>Local Auctions in The Bahamas: </strong>Enabling sellers
                to list vehicles and buyers to bid on them, with BidCaribbean
                acting as a trusted third-party facilitator.
              </p>
            </li>
          </ol>
        </section>

        <section className="mb-[3vw] text-[1.5vw]">
          <h2 className="text-[2vw] font-semibold mb-[1vw]">
            5. Refundable Security Deposit{" "}
          </h2>
          <p className="">
            Before you can bid on and purchase vehicles on our website,
            BidCaribbean requires a refundable security deposit (the “Deposit”).
            The deposit amounts are as follows:
          </p>

          <ol className="list-disc pl-[3vw] text-[1.5vw] space-y-[0.5vw]">
            <li>
              <p className="">
                <strong>Local Auctions:</strong>A minimum deposit of{" "}
                <strong>350 BSD</strong> is required for bids up to{" "}
                <strong>3,500 BSD.</strong>
              </p>
            </li>

            <li>
              <p className="">
                <strong>International Auctions: </strong> A minimum deposit of{" "}
                <strong>750 BSD</strong> is required for bids up to{" "}
                <strong>7,500 USD.</strong>
              </p>
            </li>
          </ol>
          <h2 className="text-[1.6vw] font-semibold">Bidding Limits:</h2>
          <p className="text-[1.5vw]">
            Your deposit determines your bidding limit. For example:
          </p>

          <ol className="list-disc pl-[3vw] text-[1.5vw] space-y-[0.5vw]">
            <li>
              <p className="">
                A <strong>750 BSD </strong>deposit allows you to bid on one
                vehicle up to<span> 7,500 USD.</span>
              </p>
            </li>
            <li>
              <p className="">
                A <strong>2,000 BSD </strong>deposit allows you to bid on a
                vehicle up to<span> 20,000 USD.</span>
              </p>
            </li>
          </ol>

          <h2 className="text-[1.6vw] font-semibold">Refund Process: </h2>

          <ol className="list-disc pl-[3vw] text-[1.5vw] space-y-[0.5vw]">
            <li>
              <p className="">
                Deposits can be made via payment card or bank wire.
              </p>
            </li>
            <li>
              <p className="">
                You may request a refund of your Deposit at any time through
                your user dashboard or by emailing us from your registered
                account email address.{" "}
              </p>
            </li>
            <li>
              <p className="">
                A <strong>4% processing fee</strong> will be deducted for
                refunds on domestically issued cards (Bahamas). For
                international cards, the processing fee is <strong>5%</strong>.{" "}
              </p>
            </li>
          </ol>

          <h2 className="text-[1.6vw] font-semibold">
            Wire Transfer Refund Policy:
          </h2>
          <p className="">
            If you add a Deposit via wire transfer, refunds will only be
            processed to the person registered with BidCaribbean at the time of
            the transaction. For example, if Joe Cruze is registered with
            BidCaribbean, any wire transfer Deposit made by Joe Cruze will only
            be refunded to Joe Cruze.
          </p>
        </section>

        <section className="mb-[3vw] text-[1.5vw]">
          <h2 className="text-[2vw] font-semibold mb-[1vw]">
            6. Placing a Bid or Creating a Buy Now Request
          </h2>

          <ol className="list-disc pl-[3vw] space-y-[0.5vw] text-[1.5vw]">
            <li>
              <p className="">
                <strong>Bidding Process: </strong> Bidding begins when a vehicle
                is assigned a sale date and continues until one hour before the
                live auction (“Cut-Off Time”). You can submit the maximum price
                you are willing to pay for the vehicle on the vehicle page. You
                may retract, lower, increase, or cancel your bid at any time
                before the Cut-Off Time.
              </p>
            </li>

            <li>
              <p className="">
                <strong>Buy Now Requests:</strong> You can create a Buy Now
                request from the lot page until one hour before the live
                auction. We will place the request at the auction site and
                attempt to negotiate the purchase. However, we cannot guarantee
                that your Buy Now request will be fulfilled, as this depends on
                the seller’s final decision. Once created, Buy Now requests
                cannot be changed or canceled.
              </p>
            </li>

            <li>
              <p className="">
                <strong>Final Bids:</strong> After the Cut-Off Time,
                BidCaribbean will register your bid at the auction site as a
                proxy bid. You cannot change, retract, or cancel your bid after
                this point. If you win the auction, you are obligated to
                purchase the vehicle or forfeit your Deposit.
                <strong> All bids are final.</strong>
              </p>
            </li>

            <li>
              <p className="">
                <strong>On Approval or Minimum Bid Auctions:</strong> If a
                vehicle is won “On Approval” or “Minimum Bid,” we will negotiate
                the final price on your behalf. If the negotiated price exceeds
                your maximum bid, we may contact you for approval. However, we
                reserve the right to increase the bidding amount up to your
                maximum bid without prior notice. If you wish to stay at your
                winning bid, you must contact us within{" "}
                <strong> one (1) hour</strong> after the purchase.
              </p>
            </li>
          </ol>

          <p className="">
            <strong>Important Note:</strong> We cannot guarantee the purchase of
            vehicles in certain locations (e.g., Wisconsin, Alabama, Michigan)
            due to licensing restrictions. We reserve the right to cancel your
            bid at any time if we do not have a valid license.
          </p>
        </section>

        <section className="mb-[3vw]">
          <h2 className="text-[2vw] font-semibold mb-[1vw]">
            7. Bid Rejection
          </h2>

          <ol className="list-disc pl-[3vw]  space-y-[0.5vw] text-[1.5vw]">
            <li>
              <p className="">
                <strong>Auction Discretion: </strong> Supported auction
                platforms (e.g., Copart, IAAI) reserve the right to void bids
                for any reason at their sole discretion.
              </p>
            </li>

            <li>
              <p className="">
                <strong>Dispute Resolution: </strong> If a dispute arises
                regarding a bid, the auction platform is the exclusive authority
                in resolving the dispute. Buyers agree to indemnify, defend, and
                hold harmless BidCaribbean, Copart, or IAAI from any liability
                arising from such decisions.
              </p>
            </li>

            <li>
              <p className="">
                <strong>Bid Cancellation: </strong>BidCaribbean reserves the
                right to cancel your bid at any time without providing a reason.
              </p>
            </li>
          </ol>
        </section>

        <section className="mb-[3vw] text-[1.5vw]">
          <h2 className="text-[2vw] font-semibold">8. Buying a Vehicle </h2>
          <h2 className="text-[1.6vw] font-semibold mb-[1vw]">
            Congratulations! You’ve Won!
          </h2>

          <p>
            Winning an auction is exciting, and BidCaribbean makes it easy to
            complete the deal. Once you’ve won, you’ll receive an instant
            notification via email and in the <strong>“Lots Won”</strong>{" "}
            section of your account. An invoice with wire transfer instructions
            will be emailed to you immediately. Payment must be made within{" "}
            <strong>2 business days</strong> and includes:
          </p>

          <ol className="list-disc pl-[3vw] text-[1.5vw] space-y-[0.5vw]">
            <li>
              <p className="">
                <strong>Auction Discretion: </strong>
              </p>
            </li>
            <li>
              <p className="">
                <strong>Applicable auction fees.</strong>
              </p>
            </li>
            <li>
              <p className="">
                <strong>Domestic Transport</strong>
              </p>
            </li>

            <li>
              <p className="">
                A <strong>1,500 BSD</strong> admin fee (or <strong>10%</strong>{" "}
                of the final bid price for vehicles priced higher than{" "}
                <strong>19,999 BSD</strong>).
              </p>
            </li>

            <li>
              <p className="">
                <strong>Documentation fees.</strong>
              </p>
            </li>
            <li>
              <p className="">
                <strong>Inspection Fees</strong>
              </p>
            </li>
          </ol>

          <h2 className="text-[1.6vw]font-semibold ">Payment Methods:</h2>
          <p>
            Payment for won vehicles must be made via{" "}
            <strong>wire transfer</strong> or{" "}
            <strong>direct bank deposit.</strong> Credit/debit cards and
            cashier’s checks are not accepted.
          </p>

          <h2 className="text-[1.6vw] font-semibold ">Ownership Transfer: </h2>
          <p>
            When you buy a vehicle on our Website, you understand that you are
            purchasing from BidCaribbean or a third party, not directly from
            Copart or IAAI. To complete the transaction, you must:
          </p>

          <ol className="list-disc pl-[3vw] space-y-[0.5vw] text-[1.5vw]">
            <li>
              <p className="">
                Sign a bill of sale and any other required legal documents.
              </p>
            </li>

            <li>
              <p className="">
                Provide a valid copy of a government-issued ID.
              </p>
            </li>

            <li>
              <p className="">Ensure all payments are made in full.</p>
            </li>
          </ol>

          <h2 className="text-[1.6vw] font-semibold ">
            International Purchases:
          </h2>
          <p>
            If you are purchasing internationally, you are fully responsible for
            all <strong> logistics, duties, customs, and fees</strong>{" "}
            associated with exporting the vehicle from the country of origin and
            importing it to The Bahamas or the Caribbean.{" "}
          </p>
        </section>

        <section className="mb-[3vw] text-[1.5vw]">
          <h2 className="text-[2vw] font-semibold">
            9. Personal Account Bidding Example{" "}
          </h2>
          <h2 className="text-[1.6vw] font-semibold">Example: </h2>
          <p>
            Jim pays an <strong>800 BSD</strong> deposit via bank wire. His
            account is supplied with an <strong>8,000 BSD</strong> bidding
            limit, allowing him to bid on one vehicle up to{" "}
            <strong>8,000 BSD.</strong>
          </p>
          <p>
            Jim bids <strong>5,000 BSD</strong> on a car. His bidding limit
            shows <strong>3,000 BSD</strong>, but he cannot bid on other cars
            because the minimum bid amount is <strong>6,000 BSD</strong> (10% of
            the bidding limit). Jim does not win the car, and the{" "}
            <strong>5,000 BSD</strong> is returned to his bidding limit,
            updating it to <strong>8,000 BSD.</strong> He then places a{" "}
            <strong>7,500 BSD</strong> bid on another car and wins it for{" "}
            <strong>6,000 BSD.</strong>
            He receives an invoice immediately, pays the full amount within 2
            days, and his <strong>800 BSD</strong> deposit is returned to his
            account. Jim can now bid on another vehicle or request a refund of
            his deposit.
          </p>
        </section>

        <section className="mb-[3vw] text-[1.5vw]">
          <h2 className="text-[2vw] font-semibold mb-[1vw]">
            10. Transaction Fees
          </h2>

          <p>BidCaribbean charges the following fees for each lot purchased:</p>

          <ol className="list-disc pl-[3vw] text-[1.5vw] space-y-[0.5vw]">
            <li>
              <p className="">
                <strong>Admin Fee: 1,500 BSD</strong> flat fee (or{" "}
                <strong>10%</strong> of the final sales price for vehicles
                priced Higher than <strong>19,999 BSD</strong>).
              </p>
            </li>
            <li>
              <p className="">
                <strong>Auction Fees:</strong> Applicable fees based on the
                final sales price (Copart or IAAI, depending on the lot).
              </p>
            </li>
            <li>
              <p className="">
                <strong>Documentation Fee:</strong> As specified in the invoice.
              </p>
            </li>
            <li>
              <p className="">
                <strong>Inspection Fees:</strong> If opted in.
              </p>
            </li>
          </ol>
          <p>
            All fees must be paid in full before the vehicle or title is
            released to the buyer.
          </p>
        </section>

        <section className="mb-[3vw] text-[1.5vw]">
          <h2 className="text-[2vw] font-semibold mb-[1vw]">
            11. Purchase Payment
          </h2>

          <ol className="list-disc pl-[3vw] text-[1.5vw] space-y-[0.5vw]">
            <li>
              <p className="">
                <strong>Payment Methods:</strong> Only{" "}
                <strong>wire transfer</strong> and{" "}
                <strong>direct bank deposit</strong> are accepted for vehicle
                payments. Credit/debit cards and cashier’s checks are not
                accepted.{" "}
              </p>
            </li>
            <li>
              <p className="">
                <strong> Payment Deadline:</strong> Payment must be made within{" "}
                <strong> 2 business days,</strong> including the sale day. For
                example, if you purchase a vehicle on March 1st, payment must be
                received by <strong>5:00 PM EST on March 2nd.</strong> Late
                payments will incur a<strong> $50 BSD </strong> fee (or{" "}
                <strong> 2% of the selling price</strong>, whichever is
                greater).{" "}
              </p>
            </li>
            <li>
              <p className="">
                <strong> Deposit Usage:</strong> Deposits made via wire transfer
                or direct bank deposit can be used as partial payment for the
                invoice or towing fees. Deposits made via payment card cannot be
                used for partial payments.{" "}
              </p>
            </li>
          </ol>
          <p>
            All fees must be paid in full before the vehicle or title is
            released to the buyer.
          </p>

          <h2 className="text-[1.6vw] font-semibold ">No Buyer’s Remorse:</h2>
          <h2 className="text-[1.6vw] font-semibold ">
            All sales are final. If payment is not made within 7 days of the
            sale, or if you cancel the purchase, you will be charged a relist
            fee of:
          </h2>

          <ol className="list-disc pl-[3vw] text-[1.5vw] space-y-[0.5vw]">
            <li>
              <p className="">
                <strong>
                  750 BSD (or 10% of the sale price, whichever is greater) for
                  Copart purchases.
                </strong>
              </p>
            </li>

            <li>
              <p className="">
                <strong>
                  1,000 BSD (or 15% of the sale price, whichever is greater) for
                  IAAI purchases.
                </strong>
              </p>
            </li>
          </ol>
          <p>
            Additionally, you are responsible for paying the admin fee,
            documentation fee, and any storage or late fees. These fees will be
            deducted from your deposit or charged to the card on file.
            BidCaribbean becomes the legal owner of the vehicle, and your
            deposit will be forfeited.
          </p>

          <h2 className="text-[2vw] font-semibold">Relist Policy:</h2>
          <p>
            Each customer is allowed only one relist. If this occurs again for
            the same customer, their access to BidCaribbean will be permanently
            revoked.
          </p>
        </section>

        <section className="mb-[3vw] text-[1.5vw]">
          <h2 className="text-[2vw] font-semibold mb-[1vw]">
            12. Title and Ownership
          </h2>

          <ol className="list-disc pl-[3vw] text-[1.5vw] space-y-[0.5vw]">
            <li>
              <p className="">
                <strong>Title Release:</strong> The title will be released to
                you once BidCaribbean has received full payment, reassigned the
                original title, and obtained your electronic signature on the
                required paperwork. After these conditions are met, the vehicle
                will be delivered to the address on file.{" "}
              </p>
            </li>
            <li>
              <p className="">
                <strong>E-Signature:</strong> You must provide an electronic
                signature on the necessary documents, including the bill of sale
                and, if applicable, a declaration affidavit. If documents are
                not signed, BidCaribbean reserves the right to retain them until
                the required signatures are provided.{" "}
              </p>
            </li>
            <li>
              <p className="">
                <strong>Pending Titles:</strong> Exercise caution when bidding
                on vehicles labeled as <strong>“title pending.”</strong> This
                means the title is not yet available, and you may incur storage
                fees while waiting for the title to be ready. Typically, titles
                are ready within <strong>45 days,</strong> but delays can occur.{" "}
              </p>
            </li>
            <li>
              <p className="">
                <strong>Title Absent:</strong> If the title is not received from
                the auction within <strong>45 days,</strong> BidCaribbean will
                take steps to resolve the issue. However, vehicles sold without
                a title (e.g., bill of sale, title of destruction) cannot be
                imported to The Bahamas or the Caribbean.{" "}
                <strong>Buyer beware:</strong> BidCaribbean is not responsible
                for vehicles without proper titles.
              </p>
            </li>
          </ol>
          <p>
            All fees must be paid in full before the vehicle or title is
            released to the buyer.
          </p>
        </section>

        <section className="mb-[3vw] text-[1.5vw]">
          <h2 className="text-[2vw] font-semibold mb-[1vw]">
            13. Transportation Services
          </h2>
          <p>
            BidCaribbean can arrange third-party transportation services for
            vehicle delivery. Please contact us for a quote or check our prices
            on the lot pages under <strong>“Price Calculator.”</strong>
          </p>

          <ol className="list-disc pl-[3vw] text-[1.5vw] space-y-[0.5vw]">
            <li>
              <p className="">
                <strong>Request Timing:</strong> Transportation requests must be
                submitted on the same day you win the auction.
              </p>
            </li>

            <li>
              <p className="">
                <strong> Payment:</strong> Shipping costs and associated fees
                must be paid in advance by the user.
              </p>
            </li>

            <li>
              <p className="">
                <strong>Liability:</strong> BidCaribbean acts as a shipping
                broker and is not responsible for:
              </p>
            </li>
          </ol>

          <ol className="list-[circle] pl-[3vw] text-[1.5vw]space-y-[0.5vw] ml-[1vw]">
            <li>
              <p className="">Damages during transportation.</p>
            </li>

            <li>
              <p className="">Shipping delays.</p>
            </li>

            <li>
              <p className="">Issues with loading/unloading.</p>
            </li>

            <li>
              <p className="">
                Extra costs for special handling (e.g., non-running vehicles).
              </p>
            </li>

            <li>
              <p className="">
                Storage fees or gate fees if the shipping company picks up the
                vehicle late.{" "}
              </p>
            </li>
          </ol>

          <h2 className="text-[2vw] font-semibold ">Export Procedure:</h2>

          <ol className="list-disc pl-[3vw] text-[1.5vw] space-y-[0.5vw]">
            <li>
              <p className="">
                If the destination country is not listed in our shipping
                calculator, you must verify with BidCaribbean whether shipping
                is possible before making a purchase. Alternatively, you must
                arrange your own shipping solution.{" "}
              </p>
            </li>

            <li>
              <p className="">
                If BidCaribbean exports the vehicle, you are responsible for all
                shipping fees. If the vehicle arrives at the destination port
                and payment is not received:{" "}
              </p>
            </li>
          </ol>

          <ol className="list-[circle] pl-[3vw] text-[1.5vw] space-y-[0.5vw] ml-[1vw]">
            <li>
              <p className="">
                Storage fees will begin <strong>5 days</strong> after arrival,
                depending on the port.
              </p>
            </li>

            <li>
              <p className="">
                If payment is not received within <strong>25 days,</strong>{" "}
                BidCaribbean becomes the legal owner of the vehicle and may sell
                it to cover shipping costs.{" "}
              </p>
            </li>
          </ol>
        </section>

        {/* 14 */}
        <section className="mb-[3vw] text-[1.5vw]">
          <h2 className="text-[2vw] font-semibold mb-[1vw]">
            14. Email Newsletter
          </h2>
          <p className="">
            By registering on our Website or communicating with us
            electronically, you agree to receive marketing and promotional
            materials via email. We will not send spam or share your email with
            third parties.
          </p>
        </section>

        {/* 15 */}
        <section className="mb-[3vw] text-[1.5vw]">
          <h2 className="text-[2vw] font-semibold mb-[1vw]">
            15. Data Security Policy
          </h2>
          <p className="">
            We take reasonable measures to protect your data, but you accept the
            risk that data transmitted electronically may be intercepted or
            accessed by unauthorized third parties. We do not store credit or
            debit card details on our site.{" "}
          </p>
        </section>

        {/* 16 */}
        <section className="mb-[3vw] text-[1.5vw]">
          <h2 className="text-[2vw] font-semibold mb-[1vw]">
            16. Viruses and Computer Misuse
          </h2>
          <p className="">
            You are responsible for protecting your devices from viruses and
            malware. You must not misuse our Website by introducing harmful
            software or attempting unauthorized access. Any breach of this
            provision will result in immediate termination of your access and
            may be reported to law enforcement.{" "}
          </p>{" "}
        </section>

        {/* 17 */}
        <section className="mb-[3vw] text-[1.5vw]">
          <h2 className="text-[2vw] font-semibold mb-[1vw]">
            17. Waiver and Release of Liability
          </h2>
          <p className="">
            You acknowledge that purchasing a vehicle carries inherent risks,
            including mechanical failures and title issues. You agree to
            release, waive, and hold harmless BidCaribbean from any liabilities
            arising from your use of the platform.
          </p>
        </section>

        {/* 18 */}
        <section className="mb-[3vw] text-[1.5vw]">
          <h2 className="text-[2vw] font-semibold mb-[1vw]">
            18. Copart and IAAI Disclaimers
          </h2>
          <p className="">
            You agree that you have read and understand the terms of Copart
            (Copart Terms) and IAAI (IAAI Terms). All vehicles are sold “as-is,
            where-is,” without any warranties.
          </p>
        </section>

        {/* 19 */}
        <section className="mb-[3vw] text-[1.5vw]">
          <h2 className="text-[2vw] font-semibold mb-[1vw]">
            19. Intellectual Property
          </h2>
          <p className="">
            You are granted a non-exclusive, non-transferable license to use our
            Website. You must not misuse or exploit any content on the platform
            without our express permission.
          </p>
        </section>

        {/* 20 */}
        <section className="mb-[3vw] text-[1.5vw]">
          <h2 className="text-[2vw] font-semibold mb-[1vw]">
            20. Governing Law
          </h2>
          <p className="">
            This Agreement is governed by the laws of The Bahamas. Any disputes
            will be resolved through binding arbitration in The Bahamas.{" "}
          </p>
        </section>

        <section className="mb-[3vw]">
          <h2 className="text-[2vw] font-semibold mb-[1vw]">
            21. Contact Information
          </h2>
          <p>For questions or support, contact BidCaribbean at:</p>

          <ol className="list-disc pl-[3vw] text-[1.5vw] space-y-[0.5vw]">
            <li>
              <p className="">
                <strong>Address: </strong> Marsh Harbour Abaco The bahamas
              </p>
            </li>
            <li>
              <p className="">
                <strong>Phone: </strong> 1242-825-9510/1954-737-5889
              </p>
            </li>
            <li>
              <p className="">
                <strong>Email: </strong> Customersupport@bidcaribbean.co
              </p>
            </li>
          </ol>
        </section>
      </div>
    </>
  );
};
export default Terms;
